import React from "react"; // Add this import at the top
import Modal from "react-bootstrap/Modal";
import { Login } from "./login/Login";
import "./modal.scss";

interface DialogProps {
  show: boolean;
  handleClose: () => void;
}

const Dialog: React.FC<DialogProps> = ({ show, handleClose }) => {
  return (
    <Modal
      className="modal-dialog-container"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
    >
      <Login handleClose={handleClose} />
    </Modal>
  );
};

export { Dialog };
